module.exports = __webpack_public_path__ + "img/tj.1c5199f6.svg";